export default {
  strict: true,
  namespaced: true,
  state: {
    list: [],
    loading: false,
    show: false,
    current: {},
    check: false
  },
  mutations: {
    resetList (state) { state.list = [] },
    setList (state, value) { state.list = value },
    setLoading (state, value) { state.loading = value },
    setShow (state, value) { state.show = value },
    setCurrent (state, value) { state.current = value },
    setAdsCheck (state, value) { state.check = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/ads/index.js